import {dateTimeUtil} from '../../../utils';

const config = [
    {
        headerKey: 'user:user.username',
        prop: 'partnerUserId'
    },
    {
        headerKey: 'Account',
        prop: 'accountName'
    },
    {
        headerKey: 'user:user.last.login',
        prop: 'lastLoginDateTime',
        type: 'datetime',
        width: 200,
        transform: accountUser => accountUser.lastLoginDateTime ? dateTimeUtil.toDisplayDateTime(accountUser.lastLoginDateTime) : null
    },
    {
        headerKey: 'user:user.type',
        prop: 'type',
        width: 80
    },
    {
        headerKey: 'user:user.authentication.type',
        prop: 'authenticationType',
        width: 150,
        transform: user => user.authenticationType === 'MTLS' ? 'mTLS' : 'Auth0'
    },
    {
        headerKey: 'common.date.modified',
        prop: 'lastModifiedDate',
        width: 200,
        sortMethod: (d1, d2) => dateTimeUtil.compareDisplayDateTime(d1, d2),
        transform: accountUser => accountUser.lastModifiedDate ? dateTimeUtil.toDisplayDateTime(accountUser.lastModifiedDate) : null
    },
    {
        headerKey: 'common.last.modified.by',
        prop: 'lastModifiedBy'
    }
];
export default config;